import React from 'react';
import { Input } from '../../common/Input';
import { useTranslation } from 'react-i18next';

interface OTPInputProps {
  value: string;
  onChange: (value: string) => void;
}

const OTPInput: React.FC<OTPInputProps> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <Input
      type="text"
      className="text-foreground"
      placeholder={t('enterOTP')}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      maxLength={6}
    />
  );
};

export default OTPInput;